/*
  i18n translation utility wrapper
  use it in the component like:

  import { useTranslation } from "inbooma-api";
  const Component = () => {
    const { t } = useTranslation();
    return (
      <div>{t('key')}</div>
    )
  }

  key could be formatted like:
  1) key
  2) keysGroupName.key
  3) namespace:key  or namespace:keysGroupName.key

  values fill {{name}} placeholders (i18next syntax):
  t('Bed {{bed}}', ns, { bed: 'A' }) returns 'Bed A'

  More:
  https://www.i18next.com/translation-function/essentials#accessing-keys

  https://www.i18next.com/translation-function/essentials#accessing-keys-in-different-namespaces

  https://www.i18next.com/translation-function/essentials#passing-a-default-value

*/
const interpolate = (key, values) =>
  values ? key.replace(/\{\{\s*(\w+)\s*\}\}/g, (placeholder, name) => values[name] ?? placeholder) : key

const useTranslation = () => {
  return {
    // @TODO commented unused var
    // eslint-disable-next-line no-unused-vars
    t: (key, ns, values) => {
      return interpolate(key, values)
    }
  }
}

// eslint-disable-next-line no-unused-vars
const t = (key, ns, values) => {
  return interpolate(key, values)
}

export { useTranslation, t }
